import onboardingResponse from '../common/markdownMessages/onboardingResponse';
import onboardingResponseParams from '../common/onboardingResponseParams';

export default onboardingResponse({
  ...onboardingResponseParams.pipedrive,
  supportLinkCode: 'telegram',
});
